export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/home.676dcc5a.svg","height":165,"width":166,"blurWidth":0,"blurHeight":0};